import React from "react";

const CellIdContext = React.createContext();

export {CellIdContext};
